import React from "react";
import {
  Slider,
  SliderChangeEvent,
  SliderLabel,
} from "@progress/kendo-react-inputs";
import s from "./KendoSlider.module.scss";

export const KendoSlider = ({
  buttons = false,
  defaultValue = 0,
  step = 1,
  min = 1,
  max = 10,
  positions,
  value,
  setValueOnChange,
  disabledCondition = false,
}: IKendoSliderProps) => {
  const onChange = (event: SliderChangeEvent) => {
    setValueOnChange(event.value);
  };

  return (
    <div className={"illio-slider"}>
      <Slider
        className={s.slider}
        buttons={buttons}
        step={step}
        value={value}
        disabled={disabledCondition}
        style={{ width: "300px" }}
        defaultValue={defaultValue}
        min={min}
        max={max}
        onChange={onChange}
      >
        {positions.map((position) => {
          return (
            <SliderLabel key={position} position={position}>
              {position}
            </SliderLabel>
          );
        })}
      </Slider>
    </div>
  );
};

export interface IKendoSliderProps {
  buttons?: boolean;
  step?: number;
  min?: number;
  max?: number;
  defaultValue?: number;
  positions: number[];
  value?: number | undefined;
  disabledCondition?: boolean;
  setValueOnChange: (value: number) => void;
}
